// extracted by mini-css-extract-plugin
export default {"video-section":"c_g d-flex","video-section--header":"c_h","video-section__frame":"c_j ml-3"};